"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});function r(t,a){return new Promise(e=>{const o=setTimeout(e,t);a.addEventListener("abort",()=>{clearTimeout(o),e()})})}exports.abortableDelay=r;
